import { MutationTree } from 'vuex'
import { ProductState } from './product.types'
import { mapVariantObjPropsToIds } from '../../utils'

export enum MutationTypes {
  SET_PRODUCT_IMAGES = 'SET_PRODUCT_IMAGES',
  SET_PRODUCT_IMAGES_LOADING_ERROR = 'SET_PRODUCT_IMAGES_LOADING_ERROR',
  SET_PRODUCT_SIZES = 'SET_PRODUCT_SIZES',
  SET_PRODUCT_SIZES_LOADING_ERROR = 'SET_PRODUCT_SIZES_LOADING_ERROR',
  SET_PRODUCT_VARIANTS = 'SET_PRODUCT_VARIANTS',
  SET_PRODUCT_VARIANTS_LOADING_ERROR = 'SET_PRODUCT_VARIANTS_LOADING_ERROR',
  DELETE_PRODUCT_VARIANT = 'DELETE_PRODUCT_VARIANT',
  SET_DELETE_VARIANT_ERROR = 'SET_DELETE_VARIANT_ERROR',
  UPDATING_VARIANT_ERROR = 'UPDATING_VARIANT_ERROR',
  SET_CREATE_VARIANT_ERROR = 'SET_CREATE_VARIANT_ERROR',
  UPDATE_QUERY = 'UPDATE_QUERY',
  SET_VARIANTS_FILTER = 'SET_VARIANTS_FILTER'
}

export const mutations: MutationTree<ProductState> = {
  [MutationTypes.SET_PRODUCT_IMAGES](state, images) {
    state.images = images
  },
  [MutationTypes.SET_VARIANTS_FILTER](state, filter) {
    state.variantsFilter = filter
  },
  [MutationTypes.SET_PRODUCT_IMAGES_LOADING_ERROR](state, error) {
    state.imagesLoadingError = error
  },
  [MutationTypes.SET_PRODUCT_SIZES](state, sizes) {
    state.sizes = sizes
  },
  [MutationTypes.SET_PRODUCT_SIZES_LOADING_ERROR](state, error) {
    state.sizesLoadingError = error
  },
  [MutationTypes.SET_PRODUCT_VARIANTS](state, variants) {
    const unpopulatedVariants = mapVariantObjPropsToIds(variants)

    state.variants = variants
    state.singleItem = { ...state.singleItem, variants: unpopulatedVariants }
  },
  [MutationTypes.SET_PRODUCT_VARIANTS_LOADING_ERROR](state, error) {
    state.variantsLoadingError = error
  },
  [MutationTypes.DELETE_PRODUCT_VARIANT](state, id) {
    state.variants = state.variants.filter(variant => variant._id !== id)
  },
  [MutationTypes.SET_DELETE_VARIANT_ERROR](state, error) {
    state.variantDeleteError = error
  },
  [MutationTypes.UPDATING_VARIANT_ERROR](state, error) {
    state.variantUpdateError = error
  },
  [MutationTypes.SET_CREATE_VARIANT_ERROR](state, error) {
    state.createVariantError = error
  },
  [MutationTypes.UPDATE_QUERY](state, update) {
    state.queryObject = { ...state.queryObject, ...update }
  }
}
